<template>
  <div class="snippet-picker">
    <button
      class="btn btn-sm btn-style-b"
      data-test="snippetpicker-button-show"
      @click.stop.prevent="showList"
    >
      <slot />
    </button>
    <snippetlist
      v-show="listShown"
      @snippet="selectSnippet"
      @hide="hideList"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import SnippetListComponent from './SnippetList.vue';

export default {
  components: {
    snippetlist: SnippetListComponent,
  },
  data() {
    return {
      listShown: false,
    };
  },
  computed: {
    ...mapGetters('graphicsTemplate', ['getTemplateSnippets']),
  },
  methods: {
    ...mapActions('graphicsTemplate', ['addTemplateSnippet']),
    showList() {
      this.listShown = true;
    },
    hideList() {
      this.listShown = false;
    },
    selectSnippet(value) {
      // They chose a snippet, add it to the template
      this.addTemplateSnippet({ value: value._id });
      this.hideList();
    },
  },
};
</script>
